import { ItemCardProps } from '@engyalo/delivery-ui-components/lib/ui/components/ItemCard'
import { DefaultProps } from '../../../interfaces'
import deepMerge from '../../../utils/deepMerge'
import {
  CounterForList,
  CounterDefaultArgs,
  CounterLinkedProducts,
  CounterRecommended,
  CounterForListBundle,
  CounterPackageArgs,
  CounterFreegoodsQuantitySelection,
} from './childProps/Counter'
import {
  CinnamonActionNames,
  CinnamonPaths,
  DefaultModalContainerNames,
  ItemListNameParam,
  ModalStatusPath,
  Referrers,
  TemplateActionNames,
  TextLibrary,
} from '../defaultConstants'
import { PriceDefault } from './childProps/Price'
import { PromotionType } from '../../../graphQL/commons'
import { ItemField } from '@engyalo/delivery-ui-components/lib/interfaces/item'
import { ETableTextType } from '@engyalo/delivery-ui-components'
import { ItemListNames } from '../../../interfaces/tag_manager'

export const ItemCardDefault: DefaultProps<ItemCardProps> = {
  price: PriceDefault,
  priceTotal: PriceDefault,
  tags: {
    items: '{{globals.tags.items}}' as any,
    map: {
      template: '{{globals.tags.map}}' as any,
    },
  },
  sideContent: {
    items: '{{globals.sideContent.items}}' as any,
    map: {
      template: '{{globals.sideContent.map}}' as any,
    },
  },
  image: {
    src: '{{config.options.placeholderImage}}',
    resizeEnabled: '{{globals.imageConfig.resizeEnabled}}' as any,
    resizeServiceUrl:
      '{{config.options.resizeServiceUrl}} || {{env.REACT_APP_RESIZER_SERVICE_URL}}' as any,
  },
  promotionDetail: {
    styles: {
      '& .Text': {
        textAlign: 'left',
        fontSize: '12px',
      },
    },
  },
  packagePriceMap: '{{globals.price.packagePriceMap}}' as any,
  outOfStockAction: {
    display: '{{default.sessionNotifications.STOCK_AVAILABLE}}' as any,
    onClick: {
      cinnamonActions: [
        {
          name: CinnamonActionNames.NOTIFY_BACK_IN_STOCK,
          args: {
            sku: '{{this.item.sku}}',
          },
        },
      ],
    } as any,
    button: {
      label: TextLibrary.PRODUCT_OUT_OF_STOCK_BUTTON_LABEL,
      variant: 'contained',
      color: 'primary',
      size: 'small',
      startIcon: 'MdCircleNotifications',
    },
    requestConfirmation: true,
    dialog: {
      confirmText: TextLibrary.PRODUCT_OUT_OF_STOCK_DIALOG_CONFIRM,
      cancelText: TextLibrary.PRODUCT_OUT_OF_STOCK_DIALOG_CANCEL,
      title: TextLibrary.PRODUCT_OUT_OF_STOCK_DIALOG_TITLE,
    } as any,
  },
}

export const ItemCardProduct = deepMerge(ItemCardDefault, {
  counter: CounterForList,
  actions: {
    cinnamonActions: [
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path: CinnamonPaths.SKU_MODAL,
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: false,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path: CinnamonPaths.SKU_RELATIVE_PARAMS.replace(
            ItemListNameParam,
            ItemListNames.CATALOG,
          ),
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: true,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.OPEN_MODAL,
        args: {
          container: DefaultModalContainerNames.PRODUCT_DETAIL,
          state: {
            item: '{{this.data}}',
          },
        },
      },
      {
        name: CinnamonActionNames.GET_PRODUCT_DETAIL,
        args: {
          sku: '{{this.data.sku}}',
          itemListName: ItemListNames.CATALOG,
        },
      },
    ],
  } as any,
  footer: {
    ...ItemCardDefault.footer,
    bundleTexts: {
      label: TextLibrary.BUNDLE_LIST_TITLE,
      selectButtonLabel: TextLibrary.BUNDLE_LIST_SELECT_BUTTON_LABEL,
      descriptionForCheckBox: TextLibrary.BUNDLE_LIST_DESCRIPTION_CHECKBOX,
      descriptionForCounters: TextLibrary.BUNDLE_LIST_DESCRIPTION_COUNTERS,
      descriptionForRadio: TextLibrary.BUNDLE_LIST_DESCRIPTION_RADIO,
    },
    packageTexts: {
      listLabel: TextLibrary.PACKAGE_LIST_TITLE,
      description: TextLibrary.PACKAGE_LIST_DESCRIPTION,
      selectButtonLabel: TextLibrary.BUNDLE_LIST_SELECT_BUTTON_LABEL,
      productNoAvailable: TextLibrary.PACKAGE_LIST_OUT_OFF_STOCK,
    },
  },
})

export const ItemCardSearch = deepMerge(ItemCardProduct, {
  actions: {
    cinnamonActions: [
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path: CinnamonPaths.SKU_MODAL_SEARCH + Referrers.SEARCH,
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: false,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path:
            CinnamonPaths.SKU_RELATIVE_PARAMS.replace(
              ItemListNameParam,
              ItemListNames.SEARCH_RESULTS,
            ) + Referrers.SEARCH,
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: true,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.OPEN_MODAL,
        args: {
          container: DefaultModalContainerNames.PRODUCT_DETAIL,
          state: {
            item: '{{this.data}}',
          },
        },
      },
      {
        name: CinnamonActionNames.GET_PRODUCT_DETAIL,
        args: {
          sku: '{{this.data.sku}}',
          itemListName: ItemListNames.SEARCH_RESULTS,
        },
      },
    ],
  } as any,
})

export const ItemCardFreegoodsQuantitySelection = deepMerge(ItemCardDefault, {
  price: undefined,
  priceTotal: undefined,
  actions: undefined,
  counter: CounterFreegoodsQuantitySelection,
  body: {
    fields: [ItemField.Name, ItemField.Description],
  },
})

export const ItemCardCatalog = deepMerge(ItemCardProduct, {
  fieldsToDisplay: '{{globals.catalog.fieldsToDisplay}}' as any,
})

export const ItemCardCatalogMultiImages = deepMerge(ItemCardCatalog, {
  header: {
    fields: [ItemField.CarouselImages],
  },
})

export const ItemCardCart = deepMerge(ItemCardProduct, {
  counterBundle: CounterForListBundle,
  actions: {
    cinnamonActions: [
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path: CinnamonPaths.SKU_RELATIVE_PARAMS.replace(
            ItemListNameParam,
            ItemListNames.CART,
          ),
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: true,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path: CinnamonPaths.SKU_MODAL,
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: false,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.OPEN_MODAL,
        args: {
          container: DefaultModalContainerNames.PRODUCT_DETAIL,
        },
      },
      {
        name: CinnamonActionNames.SET_SUBITEMS,
        args: {
          state: {
            subItem: '{{this.data.subItem}}',
            subItems: '{{this.data.subItemsProduct}}',
          },
        },
      },
      {
        name: CinnamonActionNames.GET_PRODUCT_DETAIL,
        args: {
          sku: '{{this.data.sku}}',
          fromCart: true,
          itemListName: ItemListNames.CART,
        },
      },
    ],
  } as any,
  sideContent: {
    items: ['item.attributes', 'deleteButton'],
  },
})

export const ItemCardProductDetailModal = deepMerge(ItemCardDefault, {
  'data-testid': 'product-detail',
  item: '{{catalog.selectedProduct}}' as any,
  layout: 'detail',
  noMemoize: true,
  elevation: 0,

  padding: 16,
  body: {
    gap: 4,
  },
  image: {
    ...ItemCardDefault.image,
    dimensions: '{{globals.imageConfig.imageSizes.productDetailImage}}' as any,
  },
  footer: {
    bundleTexts: {
      label: TextLibrary.BUNDLE_LIST_TITLE,
      descriptionForCheckBox: TextLibrary.BUNDLE_LIST_DESCRIPTION_CHECKBOX,
      descriptionForCounters: TextLibrary.BUNDLE_LIST_DESCRIPTION_COUNTERS,
      descriptionForRadio: TextLibrary.BUNDLE_LIST_DESCRIPTION_RADIO,
    },
    packageTexts: {
      listLabel: TextLibrary.PACKAGE_LIST_TITLE,
      description: TextLibrary.PACKAGE_LIST_DESCRIPTION,
      selectButtonLabel: TextLibrary.BUNDLE_LIST_SELECT_BUTTON_LABEL,
      productNoAvailable: TextLibrary.PACKAGE_LIST_OUT_OFF_STOCK,
    },
    bundlesHandler: {
      cinnamonActions: [
        {
          name: CinnamonActionNames.BUNDLES_HANDLER,
          args: {
            selections: '{{this.selections}}',
            completed: '{{this.completed}}',
            item: '{{this.item}}',
          },
        },
      ],
    } as any,
    packagesProps: {
      addToCart: {
        cinnamonActions: [
          {
            name: CinnamonActionNames.ADD_ITEM_TO_CART,
            args: CounterPackageArgs,
          },
        ],
      } as any,
      removeFromCart: {
        cinnamonActions: [
          {
            name: CinnamonActionNames.REMOVE_ITEM_FROM_CART,
            args: CounterPackageArgs,
          },
        ],
      } as any,
      disabledActions: {
        cinnamonActions: [
          {
            name: CinnamonActionNames.OPEN_DIALOG,
            args: {
              icon: {
                name: 'MdCheck',
              },
              title: TextLibrary.PRODUCT_STOCK_TITLE,
              message: TextLibrary.PRODUCT_STOCK_MESSAGE,
              buttons: [
                {
                  label: TextLibrary.ACTIONS_ACCEPT,
                  actions: {
                    cinnamonActions: [
                      {
                        name: CinnamonActionNames.CLOSE_DIALOG,
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      } as any,
    },
  },
  standalone: true,
  sideContent: {
    items: ['backButton'],
    map: {
      backButton: {
        type: 'iconButton',
        area: 'top',
        side: 'end',
        float: true,
        props: {
          icon: 'MdExpandMore',
          actions: {
            cinnamonActions: [
              {
                name: CinnamonActionNames.CLOSE_MODAL,
                args: {
                  container: DefaultModalContainerNames.PRODUCT_DETAIL,
                },
              },
              {
                name: CinnamonActionNames.PERFORM_MODAL_ACTIONS,
                args: {
                  container: DefaultModalContainerNames.PRODUCT_DETAIL,
                  modalStatus: ModalStatusPath.PRODUCT_DETAIL,
                },
              },
            ],
          },
        },
      },
    },
  },
})

export const ItemCardProductDetailPage = deepMerge(ItemCardProductDetailModal, {
  sideContent: undefined,
  noMemoize: true,
  layout: 'detailFullPage',
  promotionDetail: {
    type: 'detail-extended',
    showIcon: true,
    icon: { name: 'CmTags', iconset: 'cm' },
    secondaryText: {
      label: TextLibrary.PROMOTION_ADD_LABEL,
      endIcon: 'MdAddCircle',
      disabled: '{{catalog.synchronizingCart}}' as any,
      onClick: {
        cinnamonActions: [
          {
            name: TemplateActionNames.PRODUCT_DETAIL_ADD_FROM_PROMOTION,
            args: {
              promotion: '{{this.data.promotion}}',
              groupIdentifier: '{{this.data.groupIdentifier}}',
            },
          },
        ],
      } as any,
      size: 'small',
      textTransform: 'none',
    },
  },
  runOnLoad: {
    cinnamonActions: [
      {
        name: CinnamonActionNames.CLOSE_MODAL,
        args: {
          container: DefaultModalContainerNames.PRODUCT_DETAIL,
        },
      },
      {
        name: CinnamonActionNames.CLOSE_MODAL,
        args: {
          container: DefaultModalContainerNames.SEARCH_PRODUCT,
        },
      },
      {
        name: CinnamonActionNames.CLOSE_MODAL,
        args: {
          container: DefaultModalContainerNames.RECOMMENDED_PRODUCT_DETAIL,
        },
      },
      {
        name: CinnamonActionNames.GET_PRODUCT_DETAIL,
        args: {
          sku: '{{params.sku}}',
        },
      },
    ],
  },
  promotionsTable: {
    columns: [
      {
        id: 'quantity',
        text: '{{texts.promotions.volumeResumeColumnQuantity}}',
        type: ETableTextType.bold,
      },
      {
        id: 'savings',
        text: '{{texts.promotions.volumeResumeColumnSavings}}',
        type: ETableTextType.highlighted,
      },
      {
        id: 'price',
        text: '{{texts.promotions.volumeResumeColumnPrice}}',
        type: ETableTextType.bold,
      },
    ],
  },
})

export const ItemCardProductDetailMetaPage = deepMerge(
  ItemCardProductDetailModal,
  {
    sideContent: undefined,
    runOnLoad: {
      cinnamonActions: [
        {
          name: CinnamonActionNames.GET_PRODUCT_DETAIL,
          args: {
            sku: '{{params.sku}}',
            promotionsTypesToExclude: [
              PromotionType.COMBO,
              PromotionType.VOLUME,
            ],
          },
        },
      ],
    },
  },
)

export const ItemCardProductRecommendedCarousel = deepMerge(ItemCardCart, {
  actions: {
    cinnamonActions: [
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path: CinnamonPaths.SKU_RELATIVE_PARAMS.replace(
            ItemListNameParam,
            ItemListNames.RECOMMENDATIONS_CAROUSEL,
          ),
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: true,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path: CinnamonPaths.SKU_MODAL,
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: false,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.OPEN_MODAL,
        args: {
          container: DefaultModalContainerNames.PRODUCT_DETAIL,
          state: {
            item: '{{this.data}}',
            subItem: '{{this.data.subItem}}',
            subItems: '{{this.data.subItemsProduct}}',
          },
        },
      },
      {
        name: CinnamonActionNames.GET_PRODUCT_DETAIL,
        args: {
          sku: '{{this.data.sku}}',
          fromCart: true,
          itemListName: ItemListNames.RECOMMENDATIONS_CAROUSEL,
        },
      },
    ],
  } as any,
  image: {
    dimensions: '{{globals.imageConfig.imageSizes.suggestedItemImage}}' as any,
  },
  price: {
    styles: {
      fontSize: '.8rem',
      '@media(max-width: 374px)': {
        fontSize: '.7rem',
      },
    },
  },
  counter: {
    minusButton: {
      actions: {
        cinnamonActions: [
          {
            name: CinnamonActionNames.REMOVE_ITEM_FROM_CART,
            args: {
              ...CounterDefaultArgs,
              referrer: Referrers.SUGGESTED_ITEMS,
            },
          },
        ],
      } as any,
    },
    plusButton: {
      actions: {
        cinnamonActions: [
          {
            name: CinnamonActionNames.ADD_ITEM_TO_CART,
            args: {
              ...CounterDefaultArgs,
              referrer: Referrers.SUGGESTED_ITEMS,
            },
          },
        ],
      } as any,
    },
    styles: {
      '@media(max-width: 374px)': {
        width: '80px',
        gap: 0,
      },
    },
  },
  header: {
    styles: {
      padding: 0,
    },
  },
  footer: {
    fields: [ItemField.Price, ItemField.Counter],
    columns: 2,
  },
  styles: {
    marginTop: '10px',
    marginBottom: '10px',
    '@media(max-width: 374px)': {
      gap: 0,
    },
  },
})

// Productized primitives stay opinion-free on image dims; tenants override per-placement via SCS props.
// `ItemListNames.RECOMMENDATIONS_CAROUSEL` is shared across sources by design —
// analytics surface = carousel; per-source split lives in `referrer`.
export const buildRecommendationCarouselItemCard = (referrer: Referrers) =>
  deepMerge(ItemCardCart, {
    actions: {
      cinnamonActions: [
        {
          name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
          args: {
            path: CinnamonPaths.SKU_RELATIVE_PARAMS.replace(
              ItemListNameParam,
              ItemListNames.RECOMMENDATIONS_CAROUSEL,
            ),
            values: [
              {
                value1: '{{config.options.productDetailView}}',
                value2: true,
              },
            ],
          },
        },
        {
          name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
          args: {
            path: CinnamonPaths.SKU_MODAL,
            values: [
              {
                value1: '{{config.options.productDetailView}}',
                value2: false,
              },
            ],
          },
        },
        {
          name: CinnamonActionNames.OPEN_MODAL,
          args: {
            container: DefaultModalContainerNames.PRODUCT_DETAIL,
            state: {
              item: '{{this.data}}',
              subItem: '{{this.data.subItem}}',
              subItems: '{{this.data.subItemsProduct}}',
            },
          },
        },
        {
          name: CinnamonActionNames.GET_PRODUCT_DETAIL,
          args: {
            sku: '{{this.data.sku}}',
            fromCart: true,
            itemListName: ItemListNames.RECOMMENDATIONS_CAROUSEL,
          },
        },
      ],
    } as any,
    price: {
      styles: {
        fontSize: '.8rem',
        '@media(max-width: 374px)': {
          fontSize: '.7rem',
        },
      },
    },
    counter: {
      minusButton: {
        actions: {
          cinnamonActions: [
            {
              name: CinnamonActionNames.REMOVE_ITEM_FROM_CART,
              args: {
                ...CounterDefaultArgs,
                referrer,
              },
            },
          ],
        } as any,
      },
      plusButton: {
        actions: {
          cinnamonActions: [
            {
              name: CinnamonActionNames.ADD_ITEM_TO_CART,
              args: {
                ...CounterDefaultArgs,
                referrer,
              },
            },
          ],
        } as any,
      },
      styles: {
        '@media(max-width: 374px)': {
          width: '80px',
          gap: 0,
        },
      },
    },
    header: {
      styles: {
        padding: 0,
      },
    },
    footer: {
      fields: [ItemField.Price, ItemField.Counter],
      columns: 2,
    },
    styles: {
      marginTop: '10px',
      marginBottom: '10px',
      '@media(max-width: 374px)': {
        gap: 0,
      },
    },
  })

export const ItemCardProductRecommendedCarouselPrefilledQuantity = deepMerge(
  ItemCardProductRecommendedCarousel,
  {
    image: {
      ...ItemCardProductRecommendedCarousel.image,
      dimensions:
        '{{globals.imageConfig.imageSizes.suggestedItemImage}}' as any,
    },
    allowLazyLoadingOnImages: false,
    counter: {
      minusButton: {
        actions: {
          cinnamonActions: [
            {
              name: CinnamonActionNames.REMOVE_ITEM_FROM_CART,
              args: {
                ...CounterDefaultArgs,
                referrer: Referrers.SUGGESTED_ITEMS,
              },
            },
          ],
        } as any,
      },
      plusButton: {
        actions: {
          cinnamonActions: [
            {
              name: CinnamonActionNames.ADD_ITEM_TO_CART,
              args: {
                ...CounterDefaultArgs,
                referrer: Referrers.SUGGESTED_ITEMS,
              },
            },
          ],
        } as any,
      },
      sideCounter: true,
      styles: {
        '@media(max-width: 374px)': {
          width: '80px',
          gap: 0,
        },
      },
    },
    header: {
      styles: {
        padding: 0,
      },
    },
    footer: {
      fields: [ItemField.Price, ItemField.Counter],
      columns: 2,
    },
    styles: {
      marginTop: '10px',
      marginBottom: '10px',
      '@media(max-width: 374px)': {
        gap: 0,
      },
    },
  },
)

export const ItemCardProductRecommended = deepMerge(ItemCardProduct, {
  name: {
    lines: 1,
  },
  counter: CounterRecommended,
  sideContent: undefined,
  actions: {
    cinnamonActions: [
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path: CinnamonPaths.SKU_MODAL,
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: false,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.CONDITIONAL_PUSH_VIEW,
        args: {
          path: CinnamonPaths.SKU_RELATIVE_RECOMMENDED.replace(
            ItemListNameParam,
            ItemListNames.RECOMMENDATIONS_LIST,
          ),
          values: [
            {
              value1: '{{config.options.productDetailView}}',
              value2: true,
            },
          ],
        },
      },
      {
        name: CinnamonActionNames.OPEN_MODAL,
        args: {
          container: DefaultModalContainerNames.RECOMMENDED_PRODUCT_DETAIL,
          state: {
            item: '{{this.data}}',
          },
        },
      },
      {
        name: CinnamonActionNames.GET_PRODUCT_DETAIL,
        args: {
          sku: '{{this.data.sku}}',
          itemListName: ItemListNames.RECOMMENDATIONS_LIST,
        },
      },
    ],
  } as any,
})

export const ItemCardProductRecommendedDetail = deepMerge(
  ItemCardProductDetailModal,
  {
    'data-testid': 'recommended-product-detail',
    sideContent: {
      items: ['closeButton'],
      map: {
        closeButton: {
          type: 'iconButton',
          area: 'top',
          side: 'start',
          float: true,
          props: {
            icon: 'MdClose',
            size: 'small',
            actions: {
              cinnamonActions: [
                {
                  name: CinnamonActionNames.CLOSE_MODAL,
                  args: {
                    container:
                      DefaultModalContainerNames.RECOMMENDED_PRODUCT_DETAIL,
                  },
                },
              ],
            },
          },
        },
      },
    },
  },
)

export const ItemCardPrefillCart = deepMerge(ItemCardProductRecommended, {
  actions: undefined,
  image: {
    dimensions:
      '{{globals.imageConfig.imageSizes.frequentlyBoughtTogetherImage}}' as any,
  },
  counter: {
    plusButton: {
      actions: {
        cinnamonActions: [
          {
            name: TemplateActionNames.PREFILL_CART_UPDATE_ITEM,
            args: {
              ...CounterDefaultArgs,
            },
          },
        ],
      } as any,
    },
    minusButton: {
      actions: {
        cinnamonActions: [
          {
            name: TemplateActionNames.PREFILL_CART_UPDATE_ITEM,
            args: {
              ...CounterDefaultArgs,
            },
          },
        ],
      } as any,
    },
  },
})

export const ItemCardLinkedProducts = deepMerge(ItemCardProductRecommended, {
  actions: undefined,
  counter: CounterLinkedProducts,
  tags: {
    items: ['item.stock', 'item.unitsPerPackage', 'item.unitDivision'],
    map: {
      stock: {
        show: true,
        conditionalProps: undefined,
      },
    },
  },
})

export const ItemCardProductDetailMultiImages = deepMerge(
  ItemCardProductDetailModal,
  {
    header: {
      item: '{{catalog.selectedProduct}}' as any,
      fields: [ItemField.CarouselImages],
    },
    carouselImages: {
      usePagination: true,
      delayTimeAutoPlay: 3000,
    },
  },
)
